'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultLegsNoble = undefined;
exports.getEventCourseLegEntries = getEventCourseLegEntries;
exports.getEventLegEntries = getEventLegEntries;

var _ErosApi = require('../apis/ErosApi');

var _bastetjs = require('bastetjs');

var _rx = require('rx');

function _getLegEntryFields() {
  return ['legNumber', 'ticks', 'entryId', 'courseId', 'eventCourseId', 'eventId'];
}

function _assembleLegEntryRecords(msg, hits) {
  return 'isLoading' in msg && msg.isLoading ? [] : hits.map(function (hit) {
    return _bastetjs.utils.entityDecoder.decode(hit);
  });
}

function _LegEntryQuery(query, size) {
  return {
    _source: _getLegEntryFields(),
    size: size || 10000, //#yolo
    sort: [{ legNumber: { order: 'asc' } }, { ticks: { order: 'asc' } }],
    query: query
  };
}

function _doLegEntryQuery(streamId, body, size) {
  var query = _LegEntryQuery(body, size);
  return _ErosApi.ErosApi.memoizeQuery(streamId, 'result_bkt_*/legentry/_search', query);
}

function getEventCourseLegEntries(_ref) {
  var eventCourseId = _ref.eventCourseId;
  var topN = _ref.topN;

  var query = { term: { eventCourseId: eventCourseId } };
  return _doLegEntryQuery('GetEventCourseLegEntries = ' + eventCourseId, query, topN).map(function (msg) {
    return _assembleLegEntryRecords(msg, msg.hits || []);
  });
}

function getEventLegEntries(_ref2) {
  var eventId = _ref2.eventId;

  var query = { term: { eventId: eventId } };
  return _doLegEntryQuery('GetEventLegEntries-' + eventId, query).map(function (msg) {
    return (msg.hits || []).reduce(function (acc, elem) {
      acc[elem.eventCourseId] = acc[elem.eventCourseId] || [];
      acc[elem.eventCourseId].push(elem);
      return acc;
    }, {});
  });
}

// For testing.
var ResultLegsNoble = exports.ResultLegsNoble = {
  getEventCourseLegEntries: getEventCourseLegEntries,
  getEventLegEntries: getEventLegEntries
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/ResultLegsNoble.js
// module id = 426
// module chunks = 0